import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { appLocales } from 'locale/locale.config';

import { entities, cms } from 'lib/cms';

import { colors } from 'styles/theme';

import Container from 'components/shared/Container/Container';
import PageHeader from 'components/shared/PageHeader/PageHeader';
import PageLayout from 'components/shared/PageLayout/PageLayout';
import Shape from 'components/shared/Shape/Shape';
import PageHead from 'components/shared/PageHead/PageHead';
import RichText from 'components/shared/RichText/RichText';

const containerCss = css`
  line-height: 1.8;
  color: ${colors.textColor};

  ul {
    list-style: disc;
    padding-left: 40px;
  }
`;

function Eligibility({ content, metadata }) {
  const { pageTitle, richTextContent } = content;

  return (
    <>
      {metadata && <PageHead {...metadata} />}
      <PageLayout>
        <PageHeader title={pageTitle}>
          <Shape
            color="purple"
            bottom={-35}
            right={-120}
            variant="pill"
            size="lg"
            zIndex={2}
            tablet
            desktop
          />

          <Shape
            color="darkPurple"
            variant="pill"
            bottom={-70}
            right={70}
            zIndex={1}
            tablet
            desktop
          />
        </PageHeader>

        <Container size="md" css={containerCss}>
          <RichText text={richTextContent}></RichText>
        </Container>
      </PageLayout>
    </>
  );
}

Eligibility.propTypes = {
  content: PropTypes.object.isRequired,
  metadata: PropTypes.object,
};

export async function getStaticPaths() {
  return {
    paths: appLocales.map(localeCode => ({ params: { locale: localeCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const content = await cms.getEntry(entities.PAGE_ELIGIBILITY, params.locale);
  const { metadata } = content;

  return { props: { content, metadata } };
}

export default Eligibility;
